import { render, staticRenderFns } from "./PerfTab.vue?vue&type=template&id=516b46ac&scoped=true&"
import script from "./PerfTab.vue?vue&type=script&lang=js&"
export * from "./PerfTab.vue?vue&type=script&lang=js&"
import style0 from "./PerfTab.vue?vue&type=style&index=0&id=516b46ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b46ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516b46ac')) {
      api.createRecord('516b46ac', component.options)
    } else {
      api.reload('516b46ac', component.options)
    }
    module.hot.accept("./PerfTab.vue?vue&type=template&id=516b46ac&scoped=true&", function () {
      api.rerender('516b46ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/perf/PerfTab.vue"
export default component.exports